import React from "react";
import { Image, View, Text, Pressable, ScrollView } from "react-native";
import { connect } from "react-redux";
import { STYLES } from "../assets/styles";
import { SCREEN_WIDTH } from "../common";
import Empty from "./Empty";
import Like from "./Like";
import Price from "./Price";

function Items({
  onItemPress = () => {},
  items = [],
  onScroll = () => {},
  navigation,
}) {
  const Item = ({ itemData, index, heightInc }) => {
    const height =
      (index + heightInc) % 2 === 0 ? SCREEN_WIDTH * 0.7 : SCREEN_WIDTH * 0.6;
    return (
      <View
        style={{
          width: "100%",
          height: height,
          marginVertical: 5,
          ...STYLES.shadow,
        }}
      >
        <View style={{ flex: 1, flexDirection: "row" }}>
          <Pressable
            onPress={() => onItemPress(itemData, index)}
            style={{ width: "100%", height: "100%", flexDirection: "row" }}
          >
            <Image
              source={{ uri: itemData.image_url }}
              resizeMode="contain"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
              }}
            />
            <Like data={itemData} navigation={navigation} />
            <View
              style={{
                alignSelf: "flex-end",
                padding: 5,
                flexDirection: "row",
                width: "100%",
                backgroundColor: "#00000030",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  color: STYLES.colors.white,
                  fontWeight: "bold",
                  fontSize: STYLES.fontSizes.small,
                }}
              >
                {itemData.title}
              </Text>
            </View>
          </Pressable>
        </View>

        <View
          style={{
            flexDirection: "row",
            paddingVertical: 10,
            paddingHorizontal: 12,
            justifyContent: "space-between",
          }}
        >
          <View
            style={{
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            {itemData.colors.map((color, index) => (
              <View
                style={[
                  STYLES.shadow,
                  {
                    width: 15,
                    height: 15,
                    marginLeft: -7.5,
                    borderRadius: 7.5,
                    backgroundColor: color,
                  },
                ]}
                key={index}
              />
            ))}
          </View>
          <Price
            discount={itemData.discount}
            price={itemData.price}
            mrp={itemData.mrp}
            size={STYLES.fontSizes.mini}
            style={{ flexDirection: "column-reverse", alignItems: "flex-end" }}
          />
        </View>
      </View>
    );
  };

  const splitSize = Math.ceil(items.length / 2);

  return (
    <>
      {items.length > 0 ? (
        <ScrollView
          showsVerticalScrollIndicator={false}
          onScroll={onScroll}
          scrollEventThrottle={16}
          scrollEnabled
        >
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              paddingVertical: 5,
              paddingHorizontal: 8,
              zIndex: -1,
            }}
          >
            <View style={{ flex: 1, paddingRight: 5 }}>
              {items.slice(0, splitSize).map((item, index) => (
                <Item itemData={item} index={index} key={index} heightInc={1} />
              ))}
            </View>
            <View style={{ flex: 1, paddingLeft: 5 }}>
              {items.slice(splitSize).map((item, index) => (
                <Item
                  itemData={item}
                  index={index + splitSize}
                  heightInc={0}
                  key={index + "sw"}
                />
              ))}
            </View>
          </View>
        </ScrollView>
      ) : (
        <Empty />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  items: state.item.items,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Items);
